import React from 'react';
import { Box, Avatar, Skeleton } from '@mui/material';
import './Post.css';

const PostSkeleton = () => {
  return (
    <div className="post">
      <div className="post__avatar">
        <Skeleton variant="circular">
          <Avatar />
        </Skeleton>
      </div>
      <div className="post__body">
        <div className="post__header">
          <div className="post__headerText">
            <Skeleton variant="text" width="40%" height={20} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="25%" height={12} sx={{ mb: 1 }} />
          </div>
          <div className="post__headerDescription">
            <Skeleton variant="text" width="90%" height={16} />
            <Skeleton variant="text" width="80%" height={16} />
          </div>
        </div>
        <Skeleton variant="rectangular" width="100%" height={150} sx={{ mb: 1 }} />
        <div className="post__footer">
          <Box display="flex" justifyContent="space-between" width="100%" mt={1}>
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="circular" width={20} height={20} />
          </Box>
        </div>
      </div>
    </div>
  );
};

export default PostSkeleton; 